export default {
      id: "search-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "ico/gefera/sprite.svg#search",
      toString: function () {
        return this.url;
      }
    }